import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";

interface CommunityModalProps extends React.ComponentProps<typeof Dialog> {}

export default function CommunityModal({
  children,
  ...props
}: CommunityModalProps) {
  return (
    <Dialog {...props}>
      <DialogContent className="rounded-t-[20px] bg-twilight-indigo">
        <DialogHeader className="border-white/10 border-b p-5">
          <DialogTitle className="text-center font-semibold text-16 text-white">
            What’s this?
          </DialogTitle>
        </DialogHeader>
        <div className="p-5">{children}</div>
        <DialogFooter className="p-5 pt-0">
          <Button
            className="h-[45px] w-full rounded-[23px]"
            onClick={() => props.onOpenChange?.(false)}
            variant="cta"
          >
            Got it
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
